/**
 * Specifies which props to inject into your component.
 */
export function dragSourceCollect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragged: monitor.isDragging(),
  };
}

export function dragTargetCollect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop(),
  };
}

export function dragLayerCollect(monitor) {
  return { 
    dndDragUnderway: monitor.isDragging() 
  };
}

/**
 * Drag and drop layers
 */

export const draggable = "draggable";
